import {handleActions} from 'redux-actions';

import {withPayload} from '/util/reducer.util';

import {POPOVER_CLOSE, POPOVER_OPEN} from '../action/popover.action';

import closePopover from './popover/closePopover';
import openPopover from './popover/openPopover';

const initialState = {
  isPopoverOpen: false,
};

export default handleActions(
  {
    [POPOVER_CLOSE]: withPayload(closePopover),
    [POPOVER_OPEN]: withPayload(openPopover),
  },
  initialState,
);
